import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/referral-marketing/ReferralMarketingClient.tsx");
